export enum SearchAutoCompleteType {
  TEXT = "text",
  SEARCH_FILTER = "search_filter",
  SUBJECTS = "subjects",
  TELESCOPE = "telescope",
  SENSOR = "sensor",
  CAMERA = "camera",
  MOUNT = "mount",
  FILTER = "filter",
  ACCESSORY = "accessory",
  SOFTWARE = "software",
  TELESCOPE_TYPES = "telescope_types",
  CAMERA_TYPES = "camera_types",
  ACQUISITION_MONTHS = "acquisition_months",
  REMOTE_SOURCE = "remote_source",
  SUBJECT_TYPE = "subject_type",
  COLOR_OR_MONO = "color_or_mono",
  MODIFIED_CAMERA = "modified_camera",
  ANIMATED = "animated",
  VIDEO = "video",
  AWARD = "award",
  COUNTRY = "country",
  DATA_SOURCE = "data_source",
  MINIMUM_DATA = "minimum_data",
  CONSTELLATION = "constellation",
  BORTLE_SCALE = "bortle_scale",
  LICENSES = "licenses",
  CAMERA_PIXEL_SIZE = "camera_pixel_size",
  FIELD_RADIUS = "field_radius",
  PIXEL_SCALE = "pixel_scale",
  TELESCOPE_DIAMETER = "telescope_diameter",
  TELESCOPE_WEIGHT = "telescope_weight",
  MOUNT_WEIGHT = "mount_weight",
  MOUNT_MAX_PAYLOAD = "mount_max_payload",
  TELESCOPE_FOCAL_LENGTH = "telescope_focal_length",
  INTEGRATION_TIME = "integration_time",
  FILTER_TYPES = "filter_types",
  SIZE = "size",
  DATE_PUBLISHED = "date_published",
  DATE_ACQUIRED = "date_acquired",
  ACQUISITION_TYPE = "acquisition_type",
  MOON_PHASE = "moon_phase",
  COORDS = "coords",
  IMAGE_SIZE = "image_size",
  GROUPS = "groups",
  PERSONAL_FILTERS = "personal_filters",
  USERS = "users",
  COLLABORATION = "collaboration"
}
